import { configureStore } from "@reduxjs/toolkit";
import {
  themeReducer,
  tenantReducer,
  authReducer,
  schoolReducer,
  studentReducer,
  permissionReducer,
  assignmentCommentReducer,
  assignmentCorrectReducer,
  filterReducer,
  parentReducer,
  maintenanceReducer,
  previewReducer,
} from "@quest/slice";

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    tenant: tenantReducer,
    auth: authReducer,
    school: schoolReducer,
    student: studentReducer,
    permissions: permissionReducer,
    assignmentComment: assignmentCommentReducer,
    assignmentCorrect: assignmentCorrectReducer,
    filter: filterReducer,
    parent: parentReducer,
    maintenance: maintenanceReducer,
    preview: previewReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
